import { Injectable, Injector } from '@angular/core';
import { upperCaseFirst } from '../helpers';
import { DriverContract } from './driver.contract';

@Injectable()
export abstract class Manager<T extends DriverContract> {

    /**
     * The list of driver instances.
     *
     * @type {any[]}
     */
    protected drivers: { [driver: string]: T } = {};

    // /**
    //  * The list of available drivers.
    //  *
    //  * @type {any[]}
    //  */
    // protected extendedDrivers: { [driver: string]: T } = {};

    /**
     * The default driver name.
     *
     * @return {string}
     */
    abstract getDefaultDriver(): string;

    constructor(protected injector: Injector) {
        this.createManagerDrivers();
    }

    /**
     * Create the drivers defined in the managers methods.
     */
    private createManagerDrivers() {
        for (const method in this) {
            if (method.startsWith('create') && method.endsWith('Driver')) {
                if (typeof this[method] === 'function') {
                    const driver = method.slice(6, method.length - 6)
                        .toLowerCase();
                    if (driver) {
                        this.drivers[driver] = this.createDriver(driver);
                    }
                }
            }
        }
    }

    /**
     * Get a driver instance.
     *
     * @param {string} driver
     */
    public driver(driver?: string) {

        if (!driver) {
            driver = this.getDefaultDriver();
        }

        if (!driver) {
            throw new Error('Unable to resolve driver for ' +
                this.constructor.name + '.');
        }

        if (!this.drivers[driver]) {
            this.drivers[driver] = this.createDriver(driver);
        }

        return this.drivers[driver];
    }

    /**
     * Create a new driver instance.
     *
     * @param {string} driver
     */
    protected createDriver(driver: string): T {
        const method = 'create' + upperCaseFirst(driver) + 'Driver';

        if (this[method] instanceof Function) {
            const instance = this[method]();

            instance.name = driver;

            this.bootDriver(instance);

            return instance;
        }

        // if (this.extendedDrivers[driver]) {
        //     return this.extendedDrivers[driver];
        // }

        throw new Error('Driver ' + driver + ' is not supported.')
    }

    /**
     * Boot the driver instances.
     *
     * @param {T} instance
     */
    protected bootDriver(instance: T) {
    }

    // /**
    //  * Register a new driver.
    //  *
    //  */
    // public extend(driver: string, instance: T) {
    //     this.extendedDrivers[driver] = instance;
    //
    //     return this;
    // }

    public getDrivers() {
        return Object.assign(Object.values(this.drivers));
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/manager/manager.ts